import { Directive, Input } from '@angular/core';
import { ValidationErrors, AbstractControl, Validator, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[sdChipMinItem]',
  providers: [{ provide: NG_VALIDATORS, useExisting: SdChipMinItemValidator, multi: true }]
})
export class SdChipMinItemValidator implements Validator {
  @Input('sdChipMinItem') func: () => string;
  validate(c: AbstractControl): ValidationErrors {
    if (this.func && typeof (this.func) === 'function') {
      const result = this.func();
      if (result) {
        return {
          minItem: result
        };
      }
      return null;
    }
    return null;
  }
}
